import { useQuery } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import axios from "axios";
import { getUserDetails } from "../utils/userDetailsUtils";

const getReviewFlowData = async (testCaseId, tcrid) => {
 const user = getUserDetails();

  try {
    const response = await axios.get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getReviewFlowData&testCaseId=${testCaseId}&companyId=${user.companyid}${tcrid ? `&tcrid=${tcrid}` : ""}`
    );
    return response.data;
  } catch (error) {
    throw new Error("Error fetching review flow data", error);
  }
};

const useGetReviewFlowDataQuery = (testCaseId, tcrid, options = {}) => {
  return useQuery({
    queryKey: ["reviewFlowData", testCaseId, tcrid],
    queryFn: () => getReviewFlowData(testCaseId, tcrid),
    enabled: !!testCaseId,
    ...options,
  });
};

export default useGetReviewFlowDataQuery;